/* NETSTAT custom theme — dewhite + cart drawer + AJAX add-to-cart + reveal */
(function(){
  // Scoate fundalul ALB din pozele de produs (flood-fill de la margini -> transparent).
  // Se aplica pe orice <img data-dewhite crossorigin="anonymous">.
  function dewhite(img){
    function run(){
      if(img.dataset.dwDone)return;
      img.dataset.dwDone=1;
      try{
        var W=img.naturalWidth,H=img.naturalHeight;if(!W||!H)throw 0;
        var c=document.createElement('canvas');c.width=W;c.height=H;
        var x=c.getContext('2d');x.drawImage(img,0,0);
        var id=x.getImageData(0,0,W,H),p=id.data;
        var seen=new Uint8Array(W*H),stack=[];
        function isWhite(i){var o=i*4;return p[o]>238&&p[o+1]>238&&p[o+2]>238;}
        for(var i=0;i<W;i++){stack.push(i,(H-1)*W+i);}
        for(var j=0;j<H;j++){stack.push(j*W,j*W+W-1);}
        while(stack.length){
          var n=stack.pop();
          if(seen[n]||!isWhite(n))continue;
          seen[n]=1;p[n*4+3]=0;
          var cx=n%W;
          if(cx>0)stack.push(n-1);
          if(cx<W-1)stack.push(n+1);
          if(n>=W)stack.push(n-W);
          if(n<W*(H-1))stack.push(n+W);
        }
        // feather pe 2 inele: marginea devine treptat transparenta (contur fin)
        var ring1=new Uint8Array(W*H);
        for(var y=1;y<H-1;y++)for(var k=1;k<W-1;k++){
          var n2=y*W+k;
          if(!seen[n2]&&(seen[n2-1]||seen[n2+1]||seen[n2-W]||seen[n2+W])){ring1[n2]=1;p[n2*4+3]=Math.min(p[n2*4+3],110);}
        }
        for(var y2=1;y2<H-1;y2++)for(var k2=1;k2<W-1;k2++){
          var n3=y2*W+k2;
          if(!seen[n3]&&!ring1[n3]&&(ring1[n3-1]||ring1[n3+1]||ring1[n3-W]||ring1[n3+W]))p[n3*4+3]=Math.min(p[n3*4+3],200);
        }
        x.putImageData(id,0,0);
        img.src=c.toDataURL('image/png');
      }catch(e){}
      img.classList.add('ready');
    }
    if(img.complete&&img.naturalWidth)run();
    else img.addEventListener('load',run,{once:true});
  }
  // Perf (Faza 6): flood-fill-ul e scump pe mobil -> il rulam esalonat in idle,
  // cate o imagine per pauza, incepand cu cele vizibile in viewport.
  var dwQueue=[],dwRunning=false;
  function dwPump(deadline){
    dwRunning=true;
    while(dwQueue.length&&(!deadline||deadline.timeRemaining()>8)){ dewhite(dwQueue.shift()); }
    if(dwQueue.length){
      if('requestIdleCallback' in window)requestIdleCallback(dwPump,{timeout:1500});
      else setTimeout(function(){dwPump();},120);
    } else dwRunning=false;
  }
  function scanDewhite(root){
    var imgs=Array.prototype.slice.call((root||document).querySelectorAll('img[data-dewhite]'));
    // vizibilele primele
    imgs.sort(function(a,b){
      var ra=a.getBoundingClientRect(),rb=b.getBoundingClientRect();
      var va=(ra.top<innerHeight&&ra.bottom>0)?0:1, vb=(rb.top<innerHeight&&rb.bottom>0)?0:1;
      return va-vb;
    });
    dwQueue=dwQueue.concat(imgs);
    if(!dwRunning){
      if('requestIdleCallback' in window)requestIdleCallback(dwPump,{timeout:1500});
      else setTimeout(function(){dwPump();},120);
    }
  }
  window.NSdewhite=scanDewhite;
  if(document.readyState!=='loading')scanDewhite();
  else document.addEventListener('DOMContentLoaded',function(){scanDewhite();});
  function fmt(c){ return (c/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' lei'; }
  function esc(s){ var d=document.createElement('div'); d.textContent=s||''; return d.innerHTML; }

  var drawer=document.querySelector('[data-cdrawer]'),
      ov=document.querySelector('[data-cd-ov]');

  function openDrawer(){ if(!drawer)return; drawer.classList.add('is-open'); ov.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); }
  function closeDrawer(){ if(!drawer)return; drawer.classList.remove('is-open'); ov.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); }
  ov&&ov.addEventListener('click',closeDrawer);
  drawer&&drawer.querySelector('[data-cd-close]').addEventListener('click',closeDrawer);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')closeDrawer(); });

  async function getCart(){ var r=await fetch('/cart.js'); return r.json(); }

  var FREESHIP = 20000; // prag livrare GRATUITĂ în easybox (bani) — 200 lei din 26.10
  function renderShip(c){
    var el=drawer.querySelector('[data-cd-ship]'); if(!el)return;
    el.hidden=false;
    if(c.item_count===0){ el.hidden=true; return; }
    if(c.total_price>=FREESHIP){
      el.className='cd-ship done';
      el.innerHTML='🎉 Felicitări — ai <b>LIVRARE GRATUITĂ în easybox</b> la comanda asta!';
    } else {
      var left=FREESHIP-c.total_price, pct=Math.min(100,Math.round(c.total_price/FREESHIP*100));
      el.className='cd-ship';
      el.innerHTML='🚚 Mai adaugă <b>'+fmt(left)+'</b> și ai <b>LIVRARE GRATUITĂ</b> <span style="opacity:.75">(în easybox, la comenzi peste 200 lei)</span>'+
        '<div class="cd-bar"><i style="width:'+pct+'%"></i></div>';
    }
  }

  function renderItems(c){
    var box=drawer.querySelector('[data-cd-items]'); if(!box)return;
    if(c.item_count===0){ box.innerHTML='<div class="cd-empty">Coșul tău este gol.<br><br><a class="btn btn--primary" href="/collections/all">Vezi produsele</a></div>'; return; }
    box.innerHTML=c.items.map(function(it,i){
      return '<div class="cd-it">'+
        '<img src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2'):'')+'" alt="'+esc(it.product_title)+'" loading="lazy">'+
        '<div><div class="cd-t">'+esc(it.product_title)+'</div>'+
        (it.variant_title&&it.variant_title!=='Default Title'?'<div class="cd-v">'+esc(it.variant_title)+'</div>':'')+
        '<div class="cd-q"><button data-cd-minus="'+(i+1)+'">−</button><span>'+it.quantity+'</span><button data-cd-plus="'+(i+1)+'" data-q="'+it.quantity+'">+</button></div></div>'+
        '<div class="cd-r"><span class="cd-p">'+fmt(it.final_line_price)+'</span>'+
        '<button class="cd-x" data-cd-rm="'+(i+1)+'">Elimină</button></div></div>';
    }).join('');
    box.querySelectorAll('[data-cd-minus]').forEach(function(b){ b.addEventListener('click',function(){ changeLine(+b.dataset.cdMinus, b.nextElementSibling.textContent*1-1); }); });
    box.querySelectorAll('[data-cd-plus]').forEach(function(b){ b.addEventListener('click',function(){ changeLine(+b.dataset.cdPlus, +b.dataset.q+1); }); });
    box.querySelectorAll('[data-cd-rm]').forEach(function(b){ b.addEventListener('click',function(){ changeLine(+b.dataset.cdRm,0); }); });
  }

  async function renderUpsell(c){
    var up=drawer.querySelector('[data-cd-up]'); if(!up)return;
    up.hidden=true;
    if(c.item_count===0)return;
    try{
      var pid=c.items[0].product_id;
      var r=await fetch('/recommendations/products.json?product_id='+pid+'&limit=4');
      var d=await r.json();
      var inCart=c.items.map(function(i){return i.product_id;});
      var recs=(d.products||[]).filter(function(p){return p.available&&inCart.indexOf(p.id)<0;}).slice(0,2);
      if(!recs.length)return;
      up.hidden=false;
      up.innerHTML='<h5>Merge perfect cu:</h5>'+recs.map(function(p){
        var v=p.variants&&p.variants[0];
        return '<div class="cd-up-it"><img src="'+(p.featured_image||'')+'" alt="'+esc(p.title)+'" loading="lazy">'+
          '<div class="t">'+esc(p.title)+'<div class="p">'+fmt(v?v.price*1:p.price)+'</div></div>'+
          '<button data-cd-add="'+(v?v.id:'')+'">+ Adaugă</button></div>';
      }).join('');
      up.querySelectorAll('[data-cd-add]').forEach(function(b){
        b.addEventListener('click',async function(){
          b.disabled=true;b.textContent='...';
          try{ await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+b.dataset.cdAdd,quantity:1})}); await refresh(true);}catch(e){b.disabled=false;b.textContent='+ Adaugă';}
        });
      });
    }catch(e){}
  }

  async function changeLine(line,q){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,q)})});
    refresh(false);
  }

  async function refresh(open){
    if(!drawer)return;
    var c=await getCart();
    document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent=c.item_count; });
    drawer.querySelector('[data-cd-count]').textContent=c.item_count;
    drawer.querySelector('[data-cd-sub]').textContent=fmt(c.total_price);
    var dr=drawer.querySelector('[data-cd-discrow]');
    if(dr){
      if(c.total_discount>0){
        dr.hidden=false;
        var dn=(c.cart_level_discount_applications&&c.cart_level_discount_applications[0]&&c.cart_level_discount_applications[0].title)||
               (c.items[0]&&c.items[0].line_level_discount_allocations&&c.items[0].line_level_discount_allocations[0]&&c.items[0].line_level_discount_allocations[0].discount_application.title)||'Reducere';
        drawer.querySelector('[data-cd-discname]').textContent='🎉 '+dn;
        drawer.querySelector('[data-cd-disc]').textContent='−'+fmt(c.total_discount);
      } else dr.hidden=true;
    }
    renderShip(c); renderItems(c); renderUpsell(c); renderGift(c);
    var co=drawer.querySelector('[data-cd-checkout]');
    if(co){var cd=sessionStorage.getItem('ns_code');co.href='/checkout'+(cd?'?discount='+encodeURIComponent(cd):'');}
    if(open)openDrawer();
  }

  /* ===== WISHLIST (favorite) ===== */
  var WKEY='ns_wish';
  function wishList(){ try{return JSON.parse(localStorage.getItem(WKEY)||'[]');}catch(e){return[];} }
  function wishUI(){
    var l=wishList();
    document.querySelectorAll('[data-wish]').forEach(function(b){ b.classList.toggle('on',l.indexOf(b.dataset.wish)>-1); });
    document.querySelectorAll('[data-wish-count]').forEach(function(e){ e.textContent=l.length; e.style.display=l.length?'grid':'none'; });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wish]'); if(!b)return;
    e.preventDefault(); e.stopPropagation();
    var l=wishList(),h=b.dataset.wish,i=l.indexOf(h);
    if(i>-1)l.splice(i,1); else l.unshift(h);
    localStorage.setItem(WKEY,JSON.stringify(l.slice(0,40))); wishUI();
  });
  window.NSwishList=wishList;
  if(document.readyState!=='loading')wishUI(); else document.addEventListener('DOMContentLoaded',wishUI);

  /* ===== drawer: impachetare cadou + mesaj ===== */
  var giftInfo=null;
  async function giftData(){
    if(giftInfo!==null)return giftInfo;
    try{ var r=await fetch('/products/impachetare-cadou-premium.js'); giftInfo=r.ok?await r.json():false; }catch(e){ giftInfo=false; }
    return giftInfo;
  }
  async function renderGift(c){
    var box=drawer.querySelector('[data-cd-giftbox]'); if(!box)return;
    var g=await giftData();
    if(!g||!g.variants[0].available||c.item_count===0){ box.hidden=true; return; }
    var gid=g.variants[0].id;
    var inCart=c.items.some(function(it){return it.variant_id===gid;});
    box.hidden=false;
    box.querySelector('[data-cd-gift]').checked=inCart;
    box.querySelector('[data-cd-giftp]').textContent='(+'+fmt(g.variants[0].price)+')';
    box.querySelector('[data-cd-note]').value=c.note||'';
    if(!box.dataset.wired){
      box.dataset.wired=1;
      box.querySelector('[data-cd-gift]').addEventListener('change',async function(ev){
        if(ev.target.checked){ await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:gid,quantity:1})}); }
        else{
          var cc=await getCart();
          var idx=cc.items.findIndex(function(it){return it.variant_id===gid;});
          if(idx>-1)await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:idx+1,quantity:0})});
        }
        refresh(false);
      });
      box.querySelector('[data-cd-note]').addEventListener('change',function(ev){
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:ev.target.value})});
      });
    }
  }

  // click pe cos -> deschide drawer (fara reload)
  document.querySelectorAll('[data-cart-link]').forEach(function(a){
    a.addEventListener('click',function(e){ if(drawer){ e.preventDefault(); refresh(true); } });
  });

  // AJAX add-to-cart pe orice formular de produs
  document.addEventListener('submit',async function(ev){
    var f=ev.target;
    if(!f.matches('form[action*="/cart/add"]'))return;
    if(f.dataset.noajax)return;
    ev.preventDefault();
    var btn=f.querySelector('[type=submit]'); var lbl=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Se adaugă…';}
    try{
      var r=await fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}});
      if(!r.ok)throw 0;
      if(btn){btn.textContent='✓ Adăugat';setTimeout(function(){btn.textContent=lbl;btn.disabled=false;},1200);}
      await refresh(true);
    }catch(e){ if(btn){btn.textContent=lbl;btn.disabled=false;} f.dataset.noajax=1; f.submit(); }
  });

  // reveal on scroll (subtil, o singura data)
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('rv-in'); io.unobserve(e.target);} });},{threshold:.08});
    document.querySelectorAll('.section, .hero, .promo').forEach(function(s){ s.classList.add('rv'); io.observe(s); });
  }

  window.NSrefreshCart=refresh;
  /* Adăugare INSTANT din carduri (15.08): fără reload de pagină — AJAX + se deschide coșul.
     Fallback: dacă AJAX-ul pică, formularul se trimite clasic. */
  document.addEventListener('submit',function(e){
    var f=e.target&&e.target.closest?e.target.closest('form.card__cta'):null;
    if(!f)return;
    e.preventDefault();
    var btn=f.querySelector('button[type=submit]'),idi=f.querySelector('[name=id]');
    if(!btn||!idi){f.submit();return;}
    var l=btn.innerHTML;btn.disabled=true;btn.textContent='Se adaugă…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:+idi.value,quantity:1}]})})
    .then(function(r){if(!r.ok)throw 0;btn.textContent='✓ Adăugat';refresh(true);
      setTimeout(function(){btn.innerHTML=l;btn.disabled=false;},1600);})
    .catch(function(){btn.innerHTML=l;btn.disabled=false;f.submit();});
  });
  refresh(false);
})();

